import { useMe } from "@/api/services/admin/auth";
import { EAdminUserRole } from "@/constants/enum";
import { AppRoutes } from "@/routes/config";
import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";

export const SuperAdminGuard: FC = () => {
  const { data: me, isLoading } = useMe();

  if (isLoading) return null;

  if (me?.data?.role !== EAdminUserRole.SUPER_ADMIN) {
    return <Navigate to={AppRoutes.pageNotFound} replace />;
  }

  return <Outlet />;
};
